/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AccountRouteImport } from './routes/account'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as ArtworkRouteImport } from './routes/artwork'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as OrdersRouteImport } from './routes/orders'
import { Route as PasswordResetRouteImport } from './routes/password-reset'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as VerifyRouteImport } from './routes/verify'
import { Route as VerifyEmailAddressChangeRouteImport } from './routes/verify-email-address-change'
import { Route as AccountIndexRouteImport } from './routes/account.index'
import { Route as AccountAddressBookRouteImport } from './routes/account.address-book'
import { Route as AccountArtworkRouteImport } from './routes/account.artwork'
import { Route as AccountNotificationsRouteImport } from './routes/account.notifications'
import { Route as AccountOrdersRouteImport } from './routes/account.orders'
import { Route as AccountPasswordRouteImport } from './routes/account.password'
import { Route as AccountProfileRouteImport } from './routes/account.profile'
import { Route as AppCustomerIdRouteImport } from './routes/app.$customerId'
import { Route as CampaignsIndexRouteImport } from './routes/campaigns.index'
import { Route as CampaignsCampaignIdRouteImport } from './routes/campaigns.$campaignId'
import { Route as CheckoutCampaignIdRouteImport } from './routes/checkout.$campaignId'
import { Route as RenderIdRouteImport } from './routes/render.$id'
import { Route as AccountAddressBookIdRouteImport } from './routes/account.address-book.$id'
import { Route as AccountDesignDesignIdRouteImport } from './routes/account.design.$designId'
import { Route as AccountOrdersCodeRouteImport } from './routes/account.orders.$code'
import { Route as AppCustomerIdAllcustomersRouteImport } from './routes/app.$customerId.allcustomers'
import { Route as AppCustomerIdAuspostSpecsRouteImport } from './routes/app.$customerId.auspost-specs'
import { Route as AppCustomerIdMyordersRouteImport } from './routes/app.$customerId.myorders'
import { Route as AppCustomerIdProductsRouteImport } from './routes/app.$customerId.products'
import { Route as AppCustomerIdSamplesRouteImport } from './routes/app.$customerId.samples'
import { Route as AppCustomerIdSettingsRouteImport } from './routes/app.$customerId.settings'
import { Route as AppCollectionsSlugRouteImport } from './routes/app.collections.$slug'
import { Route as CheckoutConfirmationCodeRouteImport } from './routes/checkout.confirmation.$code'
import { Route as AppCustomerIdMycampaignsIndexRouteImport } from './routes/app.$customerId.mycampaigns.index'
import { Route as AppCustomerIdMycampaignsCampaignIdRouteImport } from './routes/app.$customerId.mycampaigns.$campaignId'
import { Route as AppCustomerIdDesignCampaignIdDesignIdRouteImport } from './routes/app.$customerId.design.$campaignId.$designId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountRoute = AccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const ArtworkRoute = ArtworkRouteImport.update({
  id: '/artwork',
  path: '/artwork',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdersRoute = OrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => rootRouteImport,
} as any)
const PasswordResetRoute = PasswordResetRouteImport.update({
  id: '/password-reset',
  path: '/password-reset',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const SignUpRoute = SignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyRoute = VerifyRouteImport.update({
  id: '/verify',
  path: '/verify',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyEmailAddressChangeRoute =
  VerifyEmailAddressChangeRouteImport.update({
    id: '/verify-email-address-change',
    path: '/verify-email-address-change',
    getParentRoute: () => rootRouteImport,
  } as any)
const AccountIndexRoute = AccountIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AccountRoute,
} as any)
const AccountAddressBookRoute = AccountAddressBookRouteImport.update({
  id: '/address-book',
  path: '/address-book',
  getParentRoute: () => AccountRoute,
} as any)
const AccountArtworkRoute = AccountArtworkRouteImport.update({
  id: '/artwork',
  path: '/artwork',
  getParentRoute: () => AccountRoute,
} as any)
const AccountNotificationsRoute = AccountNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => AccountRoute,
} as any)
const AccountOrdersRoute = AccountOrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => AccountRoute,
} as any)
const AccountPasswordRoute = AccountPasswordRouteImport.update({
  id: '/password',
  path: '/password',
  getParentRoute: () => AccountRoute,
} as any)
const AccountProfileRoute = AccountProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AccountRoute,
} as any)
const AppCustomerIdRoute = AppCustomerIdRouteImport.update({
  id: '/app/$customerId',
  path: '/app/$customerId',
  getParentRoute: () => rootRouteImport,
} as any)
const CampaignsIndexRoute = CampaignsIndexRouteImport.update({
  id: '/campaigns/',
  path: '/campaigns/',
  getParentRoute: () => rootRouteImport,
} as any)
const CampaignsCampaignIdRoute = CampaignsCampaignIdRouteImport.update({
  id: '/campaigns/$campaignId',
  path: '/campaigns/$campaignId',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckoutCampaignIdRoute = CheckoutCampaignIdRouteImport.update({
  id: '/checkout/$campaignId',
  path: '/checkout/$campaignId',
  getParentRoute: () => rootRouteImport,
} as any)
const RenderIdRoute = RenderIdRouteImport.update({
  id: '/render/$id',
  path: '/render/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountAddressBookIdRoute = AccountAddressBookIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AccountAddressBookRoute,
} as any)
const AccountDesignDesignIdRoute = AccountDesignDesignIdRouteImport.update({
  id: '/design/$designId',
  path: '/design/$designId',
  getParentRoute: () => AccountRoute,
} as any)
const AccountOrdersCodeRoute = AccountOrdersCodeRouteImport.update({
  id: '/$code',
  path: '/$code',
  getParentRoute: () => AccountOrdersRoute,
} as any)
const AppCustomerIdAllcustomersRoute =
  AppCustomerIdAllcustomersRouteImport.update({
    id: '/allcustomers',
    path: '/allcustomers',
    getParentRoute: () => AppCustomerIdRoute,
  } as any)
const AppCustomerIdAuspostSpecsRoute =
  AppCustomerIdAuspostSpecsRouteImport.update({
    id: '/auspost-specs',
    path: '/auspost-specs',
    getParentRoute: () => AppCustomerIdRoute,
  } as any)
const AppCustomerIdMyordersRoute = AppCustomerIdMyordersRouteImport.update({
  id: '/myorders',
  path: '/myorders',
  getParentRoute: () => AppCustomerIdRoute,
} as any)
const AppCustomerIdProductsRoute = AppCustomerIdProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => AppCustomerIdRoute,
} as any)
const AppCustomerIdSamplesRoute = AppCustomerIdSamplesRouteImport.update({
  id: '/samples',
  path: '/samples',
  getParentRoute: () => AppCustomerIdRoute,
} as any)
const AppCustomerIdSettingsRoute = AppCustomerIdSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppCustomerIdRoute,
} as any)
const AppCollectionsSlugRoute = AppCollectionsSlugRouteImport.update({
  id: '/app/collections/$slug',
  path: '/app/collections/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckoutConfirmationCodeRoute =
  CheckoutConfirmationCodeRouteImport.update({
    id: '/checkout/confirmation/$code',
    path: '/checkout/confirmation/$code',
    getParentRoute: () => rootRouteImport,
  } as any)
const AppCustomerIdMycampaignsIndexRoute =
  AppCustomerIdMycampaignsIndexRouteImport.update({
    id: '/mycampaigns/',
    path: '/mycampaigns/',
    getParentRoute: () => AppCustomerIdRoute,
  } as any)
const AppCustomerIdMycampaignsCampaignIdRoute =
  AppCustomerIdMycampaignsCampaignIdRouteImport.update({
    id: '/mycampaigns/$campaignId',
    path: '/mycampaigns/$campaignId',
    getParentRoute: () => AppCustomerIdRoute,
  } as any)
const AppCustomerIdDesignCampaignIdDesignIdRoute =
  AppCustomerIdDesignCampaignIdDesignIdRouteImport.update({
    id: '/design/$campaignId/$designId',
    path: '/design/$campaignId/$designId',
    getParentRoute: () => AppCustomerIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/account': typeof AccountRouteWithChildren
  '/admin': typeof AdminRoute
  '/artwork': typeof ArtworkRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/orders': typeof OrdersRoute
  '/password-reset': typeof PasswordResetRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/verify': typeof VerifyRoute
  '/verify-email-address-change': typeof VerifyEmailAddressChangeRoute
  '/account/address-book': typeof AccountAddressBookRouteWithChildren
  '/account/artwork': typeof AccountArtworkRoute
  '/account/notifications': typeof AccountNotificationsRoute
  '/account/orders': typeof AccountOrdersRouteWithChildren
  '/account/password': typeof AccountPasswordRoute
  '/account/profile': typeof AccountProfileRoute
  '/app/$customerId': typeof AppCustomerIdRouteWithChildren
  '/campaigns/$campaignId': typeof CampaignsCampaignIdRoute
  '/checkout/$campaignId': typeof CheckoutCampaignIdRoute
  '/render/$id': typeof RenderIdRoute
  '/account/': typeof AccountIndexRoute
  '/campaigns/': typeof CampaignsIndexRoute
  '/account/address-book/$id': typeof AccountAddressBookIdRoute
  '/account/design/$designId': typeof AccountDesignDesignIdRoute
  '/account/orders/$code': typeof AccountOrdersCodeRoute
  '/app/$customerId/allcustomers': typeof AppCustomerIdAllcustomersRoute
  '/app/$customerId/auspost-specs': typeof AppCustomerIdAuspostSpecsRoute
  '/app/$customerId/myorders': typeof AppCustomerIdMyordersRoute
  '/app/$customerId/products': typeof AppCustomerIdProductsRoute
  '/app/$customerId/samples': typeof AppCustomerIdSamplesRoute
  '/app/$customerId/settings': typeof AppCustomerIdSettingsRoute
  '/app/collections/$slug': typeof AppCollectionsSlugRoute
  '/checkout/confirmation/$code': typeof CheckoutConfirmationCodeRoute
  '/app/$customerId/mycampaigns/$campaignId': typeof AppCustomerIdMycampaignsCampaignIdRoute
  '/app/$customerId/mycampaigns/': typeof AppCustomerIdMycampaignsIndexRoute
  '/app/$customerId/design/$campaignId/$designId': typeof AppCustomerIdDesignCampaignIdDesignIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/artwork': typeof ArtworkRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/orders': typeof OrdersRoute
  '/password-reset': typeof PasswordResetRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/verify': typeof VerifyRoute
  '/verify-email-address-change': typeof VerifyEmailAddressChangeRoute
  '/account/address-book': typeof AccountAddressBookRouteWithChildren
  '/account/artwork': typeof AccountArtworkRoute
  '/account/notifications': typeof AccountNotificationsRoute
  '/account/orders': typeof AccountOrdersRouteWithChildren
  '/account/password': typeof AccountPasswordRoute
  '/account/profile': typeof AccountProfileRoute
  '/app/$customerId': typeof AppCustomerIdRouteWithChildren
  '/campaigns/$campaignId': typeof CampaignsCampaignIdRoute
  '/checkout/$campaignId': typeof CheckoutCampaignIdRoute
  '/render/$id': typeof RenderIdRoute
  '/account': typeof AccountIndexRoute
  '/campaigns': typeof CampaignsIndexRoute
  '/account/address-book/$id': typeof AccountAddressBookIdRoute
  '/account/design/$designId': typeof AccountDesignDesignIdRoute
  '/account/orders/$code': typeof AccountOrdersCodeRoute
  '/app/$customerId/allcustomers': typeof AppCustomerIdAllcustomersRoute
  '/app/$customerId/auspost-specs': typeof AppCustomerIdAuspostSpecsRoute
  '/app/$customerId/myorders': typeof AppCustomerIdMyordersRoute
  '/app/$customerId/products': typeof AppCustomerIdProductsRoute
  '/app/$customerId/samples': typeof AppCustomerIdSamplesRoute
  '/app/$customerId/settings': typeof AppCustomerIdSettingsRoute
  '/app/collections/$slug': typeof AppCollectionsSlugRoute
  '/checkout/confirmation/$code': typeof CheckoutConfirmationCodeRoute
  '/app/$customerId/mycampaigns/$campaignId': typeof AppCustomerIdMycampaignsCampaignIdRoute
  '/app/$customerId/mycampaigns': typeof AppCustomerIdMycampaignsIndexRoute
  '/app/$customerId/design/$campaignId/$designId': typeof AppCustomerIdDesignCampaignIdDesignIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/account': typeof AccountRouteWithChildren
  '/admin': typeof AdminRoute
  '/artwork': typeof ArtworkRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/orders': typeof OrdersRoute
  '/password-reset': typeof PasswordResetRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/verify': typeof VerifyRoute
  '/verify-email-address-change': typeof VerifyEmailAddressChangeRoute
  '/account/address-book': typeof AccountAddressBookRouteWithChildren
  '/account/artwork': typeof AccountArtworkRoute
  '/account/notifications': typeof AccountNotificationsRoute
  '/account/orders': typeof AccountOrdersRouteWithChildren
  '/account/password': typeof AccountPasswordRoute
  '/account/profile': typeof AccountProfileRoute
  '/app/$customerId': typeof AppCustomerIdRouteWithChildren
  '/campaigns/$campaignId': typeof CampaignsCampaignIdRoute
  '/checkout/$campaignId': typeof CheckoutCampaignIdRoute
  '/render/$id': typeof RenderIdRoute
  '/account/': typeof AccountIndexRoute
  '/campaigns/': typeof CampaignsIndexRoute
  '/account/address-book/$id': typeof AccountAddressBookIdRoute
  '/account/design/$designId': typeof AccountDesignDesignIdRoute
  '/account/orders/$code': typeof AccountOrdersCodeRoute
  '/app/$customerId/allcustomers': typeof AppCustomerIdAllcustomersRoute
  '/app/$customerId/auspost-specs': typeof AppCustomerIdAuspostSpecsRoute
  '/app/$customerId/myorders': typeof AppCustomerIdMyordersRoute
  '/app/$customerId/products': typeof AppCustomerIdProductsRoute
  '/app/$customerId/samples': typeof AppCustomerIdSamplesRoute
  '/app/$customerId/settings': typeof AppCustomerIdSettingsRoute
  '/app/collections/$slug': typeof AppCollectionsSlugRoute
  '/checkout/confirmation/$code': typeof CheckoutConfirmationCodeRoute
  '/app/$customerId/mycampaigns/$campaignId': typeof AppCustomerIdMycampaignsCampaignIdRoute
  '/app/$customerId/mycampaigns/': typeof AppCustomerIdMycampaignsIndexRoute
  '/app/$customerId/design/$campaignId/$designId': typeof AppCustomerIdDesignCampaignIdDesignIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/account'
    | '/admin'
    | '/artwork'
    | '/forgot-password'
    | '/orders'
    | '/password-reset'
    | '/sign-in'
    | '/sign-up'
    | '/verify'
    | '/verify-email-address-change'
    | '/account/address-book'
    | '/account/artwork'
    | '/account/notifications'
    | '/account/orders'
    | '/account/password'
    | '/account/profile'
    | '/app/$customerId'
    | '/campaigns/$campaignId'
    | '/checkout/$campaignId'
    | '/render/$id'
    | '/account/'
    | '/campaigns/'
    | '/account/address-book/$id'
    | '/account/design/$designId'
    | '/account/orders/$code'
    | '/app/$customerId/allcustomers'
    | '/app/$customerId/auspost-specs'
    | '/app/$customerId/myorders'
    | '/app/$customerId/products'
    | '/app/$customerId/samples'
    | '/app/$customerId/settings'
    | '/app/collections/$slug'
    | '/checkout/confirmation/$code'
    | '/app/$customerId/mycampaigns/$campaignId'
    | '/app/$customerId/mycampaigns/'
    | '/app/$customerId/design/$campaignId/$designId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/artwork'
    | '/forgot-password'
    | '/orders'
    | '/password-reset'
    | '/sign-in'
    | '/sign-up'
    | '/verify'
    | '/verify-email-address-change'
    | '/account/address-book'
    | '/account/artwork'
    | '/account/notifications'
    | '/account/orders'
    | '/account/password'
    | '/account/profile'
    | '/app/$customerId'
    | '/campaigns/$campaignId'
    | '/checkout/$campaignId'
    | '/render/$id'
    | '/account'
    | '/campaigns'
    | '/account/address-book/$id'
    | '/account/design/$designId'
    | '/account/orders/$code'
    | '/app/$customerId/allcustomers'
    | '/app/$customerId/auspost-specs'
    | '/app/$customerId/myorders'
    | '/app/$customerId/products'
    | '/app/$customerId/samples'
    | '/app/$customerId/settings'
    | '/app/collections/$slug'
    | '/checkout/confirmation/$code'
    | '/app/$customerId/mycampaigns/$campaignId'
    | '/app/$customerId/mycampaigns'
    | '/app/$customerId/design/$campaignId/$designId'
  id:
    | '__root__'
    | '/'
    | '/account'
    | '/admin'
    | '/artwork'
    | '/forgot-password'
    | '/orders'
    | '/password-reset'
    | '/sign-in'
    | '/sign-up'
    | '/verify'
    | '/verify-email-address-change'
    | '/account/address-book'
    | '/account/artwork'
    | '/account/notifications'
    | '/account/orders'
    | '/account/password'
    | '/account/profile'
    | '/app/$customerId'
    | '/campaigns/$campaignId'
    | '/checkout/$campaignId'
    | '/render/$id'
    | '/account/'
    | '/campaigns/'
    | '/account/address-book/$id'
    | '/account/design/$designId'
    | '/account/orders/$code'
    | '/app/$customerId/allcustomers'
    | '/app/$customerId/auspost-specs'
    | '/app/$customerId/myorders'
    | '/app/$customerId/products'
    | '/app/$customerId/samples'
    | '/app/$customerId/settings'
    | '/app/collections/$slug'
    | '/checkout/confirmation/$code'
    | '/app/$customerId/mycampaigns/$campaignId'
    | '/app/$customerId/mycampaigns/'
    | '/app/$customerId/design/$campaignId/$designId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccountRoute: typeof AccountRouteWithChildren
  AdminRoute: typeof AdminRoute
  ArtworkRoute: typeof ArtworkRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  OrdersRoute: typeof OrdersRoute
  PasswordResetRoute: typeof PasswordResetRoute
  SignInRoute: typeof SignInRoute
  SignUpRoute: typeof SignUpRoute
  VerifyRoute: typeof VerifyRoute
  VerifyEmailAddressChangeRoute: typeof VerifyEmailAddressChangeRoute
  AppCustomerIdRoute: typeof AppCustomerIdRouteWithChildren
  CampaignsCampaignIdRoute: typeof CampaignsCampaignIdRoute
  CheckoutCampaignIdRoute: typeof CheckoutCampaignIdRoute
  RenderIdRoute: typeof RenderIdRoute
  CampaignsIndexRoute: typeof CampaignsIndexRoute
  AppCollectionsSlugRoute: typeof AppCollectionsSlugRoute
  CheckoutConfirmationCodeRoute: typeof CheckoutConfirmationCodeRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account': {
      id: '/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/artwork': {
      id: '/artwork'
      path: '/artwork'
      fullPath: '/artwork'
      preLoaderRoute: typeof ArtworkRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders': {
      id: '/orders'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof OrdersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/password-reset': {
      id: '/password-reset'
      path: '/password-reset'
      fullPath: '/password-reset'
      preLoaderRoute: typeof PasswordResetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify': {
      id: '/verify'
      path: '/verify'
      fullPath: '/verify'
      preLoaderRoute: typeof VerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify-email-address-change': {
      id: '/verify-email-address-change'
      path: '/verify-email-address-change'
      fullPath: '/verify-email-address-change'
      preLoaderRoute: typeof VerifyEmailAddressChangeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account/': {
      id: '/account/'
      path: '/'
      fullPath: '/account/'
      preLoaderRoute: typeof AccountIndexRouteImport
      parentRoute: typeof AccountRoute
    }
    '/account/address-book': {
      id: '/account/address-book'
      path: '/address-book'
      fullPath: '/account/address-book'
      preLoaderRoute: typeof AccountAddressBookRouteImport
      parentRoute: typeof AccountRoute
    }
    '/account/artwork': {
      id: '/account/artwork'
      path: '/artwork'
      fullPath: '/account/artwork'
      preLoaderRoute: typeof AccountArtworkRouteImport
      parentRoute: typeof AccountRoute
    }
    '/account/notifications': {
      id: '/account/notifications'
      path: '/notifications'
      fullPath: '/account/notifications'
      preLoaderRoute: typeof AccountNotificationsRouteImport
      parentRoute: typeof AccountRoute
    }
    '/account/orders': {
      id: '/account/orders'
      path: '/orders'
      fullPath: '/account/orders'
      preLoaderRoute: typeof AccountOrdersRouteImport
      parentRoute: typeof AccountRoute
    }
    '/account/password': {
      id: '/account/password'
      path: '/password'
      fullPath: '/account/password'
      preLoaderRoute: typeof AccountPasswordRouteImport
      parentRoute: typeof AccountRoute
    }
    '/account/profile': {
      id: '/account/profile'
      path: '/profile'
      fullPath: '/account/profile'
      preLoaderRoute: typeof AccountProfileRouteImport
      parentRoute: typeof AccountRoute
    }
    '/app/$customerId': {
      id: '/app/$customerId'
      path: '/app/$customerId'
      fullPath: '/app/$customerId'
      preLoaderRoute: typeof AppCustomerIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/campaigns/': {
      id: '/campaigns/'
      path: '/campaigns'
      fullPath: '/campaigns/'
      preLoaderRoute: typeof CampaignsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/campaigns/$campaignId': {
      id: '/campaigns/$campaignId'
      path: '/campaigns/$campaignId'
      fullPath: '/campaigns/$campaignId'
      preLoaderRoute: typeof CampaignsCampaignIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout/$campaignId': {
      id: '/checkout/$campaignId'
      path: '/checkout/$campaignId'
      fullPath: '/checkout/$campaignId'
      preLoaderRoute: typeof CheckoutCampaignIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/render/$id': {
      id: '/render/$id'
      path: '/render/$id'
      fullPath: '/render/$id'
      preLoaderRoute: typeof RenderIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account/address-book/$id': {
      id: '/account/address-book/$id'
      path: '/$id'
      fullPath: '/account/address-book/$id'
      preLoaderRoute: typeof AccountAddressBookIdRouteImport
      parentRoute: typeof AccountAddressBookRoute
    }
    '/account/design/$designId': {
      id: '/account/design/$designId'
      path: '/design/$designId'
      fullPath: '/account/design/$designId'
      preLoaderRoute: typeof AccountDesignDesignIdRouteImport
      parentRoute: typeof AccountRoute
    }
    '/account/orders/$code': {
      id: '/account/orders/$code'
      path: '/$code'
      fullPath: '/account/orders/$code'
      preLoaderRoute: typeof AccountOrdersCodeRouteImport
      parentRoute: typeof AccountOrdersRoute
    }
    '/app/$customerId/allcustomers': {
      id: '/app/$customerId/allcustomers'
      path: '/allcustomers'
      fullPath: '/app/$customerId/allcustomers'
      preLoaderRoute: typeof AppCustomerIdAllcustomersRouteImport
      parentRoute: typeof AppCustomerIdRoute
    }
    '/app/$customerId/auspost-specs': {
      id: '/app/$customerId/auspost-specs'
      path: '/auspost-specs'
      fullPath: '/app/$customerId/auspost-specs'
      preLoaderRoute: typeof AppCustomerIdAuspostSpecsRouteImport
      parentRoute: typeof AppCustomerIdRoute
    }
    '/app/$customerId/myorders': {
      id: '/app/$customerId/myorders'
      path: '/myorders'
      fullPath: '/app/$customerId/myorders'
      preLoaderRoute: typeof AppCustomerIdMyordersRouteImport
      parentRoute: typeof AppCustomerIdRoute
    }
    '/app/$customerId/products': {
      id: '/app/$customerId/products'
      path: '/products'
      fullPath: '/app/$customerId/products'
      preLoaderRoute: typeof AppCustomerIdProductsRouteImport
      parentRoute: typeof AppCustomerIdRoute
    }
    '/app/$customerId/samples': {
      id: '/app/$customerId/samples'
      path: '/samples'
      fullPath: '/app/$customerId/samples'
      preLoaderRoute: typeof AppCustomerIdSamplesRouteImport
      parentRoute: typeof AppCustomerIdRoute
    }
    '/app/$customerId/settings': {
      id: '/app/$customerId/settings'
      path: '/settings'
      fullPath: '/app/$customerId/settings'
      preLoaderRoute: typeof AppCustomerIdSettingsRouteImport
      parentRoute: typeof AppCustomerIdRoute
    }
    '/app/collections/$slug': {
      id: '/app/collections/$slug'
      path: '/app/collections/$slug'
      fullPath: '/app/collections/$slug'
      preLoaderRoute: typeof AppCollectionsSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout/confirmation/$code': {
      id: '/checkout/confirmation/$code'
      path: '/checkout/confirmation/$code'
      fullPath: '/checkout/confirmation/$code'
      preLoaderRoute: typeof CheckoutConfirmationCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/$customerId/mycampaigns/': {
      id: '/app/$customerId/mycampaigns/'
      path: '/mycampaigns'
      fullPath: '/app/$customerId/mycampaigns/'
      preLoaderRoute: typeof AppCustomerIdMycampaignsIndexRouteImport
      parentRoute: typeof AppCustomerIdRoute
    }
    '/app/$customerId/mycampaigns/$campaignId': {
      id: '/app/$customerId/mycampaigns/$campaignId'
      path: '/mycampaigns/$campaignId'
      fullPath: '/app/$customerId/mycampaigns/$campaignId'
      preLoaderRoute: typeof AppCustomerIdMycampaignsCampaignIdRouteImport
      parentRoute: typeof AppCustomerIdRoute
    }
    '/app/$customerId/design/$campaignId/$designId': {
      id: '/app/$customerId/design/$campaignId/$designId'
      path: '/design/$campaignId/$designId'
      fullPath: '/app/$customerId/design/$campaignId/$designId'
      preLoaderRoute: typeof AppCustomerIdDesignCampaignIdDesignIdRouteImport
      parentRoute: typeof AppCustomerIdRoute
    }
  }
}

interface AccountAddressBookRouteChildren {
  AccountAddressBookIdRoute: typeof AccountAddressBookIdRoute
}

const AccountAddressBookRouteChildren: AccountAddressBookRouteChildren = {
  AccountAddressBookIdRoute: AccountAddressBookIdRoute,
}

const AccountAddressBookRouteWithChildren =
  AccountAddressBookRoute._addFileChildren(AccountAddressBookRouteChildren)

interface AccountOrdersRouteChildren {
  AccountOrdersCodeRoute: typeof AccountOrdersCodeRoute
}

const AccountOrdersRouteChildren: AccountOrdersRouteChildren = {
  AccountOrdersCodeRoute: AccountOrdersCodeRoute,
}

const AccountOrdersRouteWithChildren = AccountOrdersRoute._addFileChildren(
  AccountOrdersRouteChildren,
)

interface AccountRouteChildren {
  AccountAddressBookRoute: typeof AccountAddressBookRouteWithChildren
  AccountArtworkRoute: typeof AccountArtworkRoute
  AccountNotificationsRoute: typeof AccountNotificationsRoute
  AccountOrdersRoute: typeof AccountOrdersRouteWithChildren
  AccountPasswordRoute: typeof AccountPasswordRoute
  AccountProfileRoute: typeof AccountProfileRoute
  AccountIndexRoute: typeof AccountIndexRoute
  AccountDesignDesignIdRoute: typeof AccountDesignDesignIdRoute
}

const AccountRouteChildren: AccountRouteChildren = {
  AccountAddressBookRoute: AccountAddressBookRouteWithChildren,
  AccountArtworkRoute: AccountArtworkRoute,
  AccountNotificationsRoute: AccountNotificationsRoute,
  AccountOrdersRoute: AccountOrdersRouteWithChildren,
  AccountPasswordRoute: AccountPasswordRoute,
  AccountProfileRoute: AccountProfileRoute,
  AccountIndexRoute: AccountIndexRoute,
  AccountDesignDesignIdRoute: AccountDesignDesignIdRoute,
}

const AccountRouteWithChildren =
  AccountRoute._addFileChildren(AccountRouteChildren)

interface AppCustomerIdRouteChildren {
  AppCustomerIdAllcustomersRoute: typeof AppCustomerIdAllcustomersRoute
  AppCustomerIdAuspostSpecsRoute: typeof AppCustomerIdAuspostSpecsRoute
  AppCustomerIdMyordersRoute: typeof AppCustomerIdMyordersRoute
  AppCustomerIdProductsRoute: typeof AppCustomerIdProductsRoute
  AppCustomerIdSamplesRoute: typeof AppCustomerIdSamplesRoute
  AppCustomerIdSettingsRoute: typeof AppCustomerIdSettingsRoute
  AppCustomerIdMycampaignsCampaignIdRoute: typeof AppCustomerIdMycampaignsCampaignIdRoute
  AppCustomerIdMycampaignsIndexRoute: typeof AppCustomerIdMycampaignsIndexRoute
  AppCustomerIdDesignCampaignIdDesignIdRoute: typeof AppCustomerIdDesignCampaignIdDesignIdRoute
}

const AppCustomerIdRouteChildren: AppCustomerIdRouteChildren = {
  AppCustomerIdAllcustomersRoute: AppCustomerIdAllcustomersRoute,
  AppCustomerIdAuspostSpecsRoute: AppCustomerIdAuspostSpecsRoute,
  AppCustomerIdMyordersRoute: AppCustomerIdMyordersRoute,
  AppCustomerIdProductsRoute: AppCustomerIdProductsRoute,
  AppCustomerIdSamplesRoute: AppCustomerIdSamplesRoute,
  AppCustomerIdSettingsRoute: AppCustomerIdSettingsRoute,
  AppCustomerIdMycampaignsCampaignIdRoute:
    AppCustomerIdMycampaignsCampaignIdRoute,
  AppCustomerIdMycampaignsIndexRoute: AppCustomerIdMycampaignsIndexRoute,
  AppCustomerIdDesignCampaignIdDesignIdRoute:
    AppCustomerIdDesignCampaignIdDesignIdRoute,
}

const AppCustomerIdRouteWithChildren = AppCustomerIdRoute._addFileChildren(
  AppCustomerIdRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccountRoute: AccountRouteWithChildren,
  AdminRoute: AdminRoute,
  ArtworkRoute: ArtworkRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  OrdersRoute: OrdersRoute,
  PasswordResetRoute: PasswordResetRoute,
  SignInRoute: SignInRoute,
  SignUpRoute: SignUpRoute,
  VerifyRoute: VerifyRoute,
  VerifyEmailAddressChangeRoute: VerifyEmailAddressChangeRoute,
  AppCustomerIdRoute: AppCustomerIdRouteWithChildren,
  CampaignsCampaignIdRoute: CampaignsCampaignIdRoute,
  CheckoutCampaignIdRoute: CheckoutCampaignIdRoute,
  RenderIdRoute: RenderIdRoute,
  CampaignsIndexRoute: CampaignsIndexRoute,
  AppCollectionsSlugRoute: AppCollectionsSlugRoute,
  CheckoutConfirmationCodeRoute: CheckoutConfirmationCodeRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
